import React from "react";

export default function TranscriptPanel({ messages, botName, botRole, botAvatar }) {
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "";
    try {
      return new Date(timestamp).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch (err) {
      console.error("Failed to format timestamp", err);
      return "";
    }
  };

  const getSpeakerLabel = (role) => {
    if (role === "client") return "You";
    if (role === "server") return botName || "Coach AI Bot";
    return role || "Unknown";
  };

  if (!messages || messages.length === 0) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg p-8">
        <div className="flex justify-center items-center flex-col space-y-3">
          <img src="/images/coming-soon.svg" alt="No transcript" className="w-32 h-32" />
          <p className="text-lg text-gray-500">No transcript available for this session.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-[#13161B] border border-gray-200 dark:border-[#22262F] rounded-lg flex flex-col max-h-[1000px] overflow-y-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
      <div className="flex-1 p-6">
        {/* <h4 className="text-base font-semibold text-gray-900 mb-4">Transcript</h4> */}
        <div className="space-y-4">
          {messages.map((entry, index) => (
            <div
              key={`${entry.role}-${entry.timestamp}-${index}`}
              className={`flex ${entry.role === "client" ? "justify-end" : "justify-start"}`}
            >
              <div className={`max-w-[85%] ${entry.role === "client" ? "text-right" : "text-left"}`}>
                <div className="text-xs mb-1 text-gray-500 dark:text-[#CECFD2] font-medium">
                  {getSpeakerLabel(entry.role)}
                </div>
                <div
                  className={`inline-block p-3 rounded-lg whitespace-pre-line text-sm dark:bg-[#0C0E12] dark:text-[#F7F7F7] dark:border-[#22262F] ${
                    entry.role === "client"
                      ? "bg-white text-[#181D27] rounded-br-sm border border-[#E9EAEB]"
                      : "bg-[#FAFAFA] border border-[#E9EAEB] text-[#181D27] rounded-bl-sm"
                  }`}
                >
                  {entry.text}
                </div>
                <div
                  className={`text-xs text-gray-400 dark:text-[#CECFD2] mt-1 ${
                    entry.role === "client" ? "text-right" : "text-left"
                  }`}
                >
                  {formatTimestamp(entry.timestamp)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
